export const HUBSPOT = 0;
export const INTEGRATION = 1;
export const PORTAL_SPECIFIC = 2;
export const CMS_HUBDB = 3;
export const HUBSPOT_EVENT = 4;
export const INTEGRATION_EVENT = 5;
export const PORTAL_SPECIFIC_EVENT = 6;